import {
    SET_PLCC_DYNAMIC_BANNER,
    GET_PLCC_BANNER_HTML,
    GET_PLCC_DETAILS_HTML,
} from '../actionTypes/CartActionTypes';

export const setPlccDynamicBanner = (plccDynamicBanner) => ({
    type: SET_PLCC_DYNAMIC_BANNER,
    plccDynamicBanner,
});

export const getPLCCBannerHtml = (href) => ({
    type: GET_PLCC_BANNER_HTML,
    href,
});
export const getPLCCDetailsHtml = (href) => ({
    type: GET_PLCC_DETAILS_HTML,
    href,
});

export default {
    setPlccDynamicBanner,
    getPLCCBannerHtml,
    getPLCCDetailsHtml,
};
